import React from 'react'
import { ShiftBadge } from 'ui'
import { useValue } from '@morningtrain/react-resources'
import PropTypes from 'prop-types'

export function Badge (props) {

  const {
    name,
  } = props

  const slug = useValue(name)

  return (
    <ShiftBadge
      slug={slug}
    />
  )
}

Badge.defaultProps = {}

Badge.propTypes = {
  name: PropTypes.string,
}

export default Badge
